import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {useActivate, useUnactivate} from "react-activation";
import {message, Modal, Breadcrumb, Space, Button, Form, Row, Col, Input, Table} from "antd";
import {FileAddOutlined, DeleteOutlined, CloseCircleOutlined, FileSearchOutlined, FileTextOutlined} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Index.module.css";

const EnterpriseIndex = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tableHeight, setTableHeight] = useState(0);
    const [enterprisePageIndex, setEnterprisePageIndex] = useState(1);
    const [enterprisePageSize, setEnterprisePageSize] = useState(store.main.pageSize);
    const [enterpriseIdList, setEnterpriseIdList] = useState([]);
    const [enterpriseTotal, setEnterpriseTotal] = useState(0);
    const [enterpriseList, setEnterpriseList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/enterprise/index"});

            handleSearchEnterprise();
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    useEffect(() => {
        handleLoadEnterprise(enterprisePageIndex, store.main.pageSize);

        //eslint-disable-next-line
    }, [store.main.pageSize]);

    useActivate(() => {
        ChuangShiOS.Notification.emit("main_set_scroll_top", {});

        handleLoadEnterprise(enterprisePageIndex, enterprisePageSize);
    });

    useUnactivate(() => {
        ChuangShiOS.Notification.emit("main_get_scroll_top", {});
    });

    const handleSearchEnterprise = () => {
        handleLoadEnterprise(1, enterprisePageSize);
    };

    const handleLoadEnterprise = (enterprisePageIndex, enterprisePageSize) => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        let data = form.getFieldsValue();
        data.pageIndex = enterprisePageIndex;
        data.pageSize = enterprisePageSize;

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/enterprise/business/website/v1/list",
            data: data,
            success: (response) => {
                setEnterprisePageIndex(enterprisePageIndex);
                setEnterprisePageSize(enterprisePageSize);
                setEnterpriseIdList([]);
                setEnterpriseTotal(response.data.total);
                setEnterpriseList(response.data.list);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                        response.data.total == "undefined" ||
                        response.data.total == null ||
                        response.data.list == "undefined" ||
                        response.data.list == null
                );
            },
        });
    };

    const handleAddEnterprise = () => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/enterprise/add",
        });
    };

    const handleEditEnterprise = (enterpriseId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/enterprise/edit/" + enterpriseId,
        });
    };

    const handleDelEnterprise = () => {
        if (enterpriseIdList.length == 0) {
            return;
        }

        if (request.current) {
            return;
        }

        Modal.confirm({
            title: "是否确认操作？",
            content: "本次数据操作后将无法恢复",
            okText: "确认",
            okType: "danger",
            okButtonProps: {
                icon: <DeleteOutlined />,
            },
            cancelText: "取消",
            cancelButtonProps: {
                icon: <CloseCircleOutlined />,
            },
            onOk: () => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                ChuangShiOS.Util.request(props, {
                    url: Application.host + "/windeal/enterprise/business/website/v1/delete",
                    data: {
                        enterpriseIdList: enterpriseIdList,
                    },
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                        setEnterpriseIdList([]);

                        handleLoadEnterprise(enterprisePageIndex, enterprisePageSize);
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            },
        });
    };

    const handleChangeEnterpriseIdList = (enterpriseIdList) => {
        setEnterpriseIdList(enterpriseIdList);
    };

    const handleChangeEnterprisePagination = (enterprisePageIndex, enterprisePageSize) => {
        handleLoadEnterprise(enterprisePageIndex, enterprisePageSize);
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<FileAddOutlined />} size="large" onClick={handleAddEnterprise}>
                                新增
                            </Button>
                            <Button
                                loading={isLoad}
                                disabled={enterpriseIdList.length == 0}
                                icon={<DeleteOutlined />}
                                size="large"
                                onClick={handleDelEnterprise}
                            >
                                删除
                            </Button>
                        </Button.Group>
                        <Button loading={isLoad} icon={<FileSearchOutlined />} type="primary" size="large" onClick={handleSearchEnterprise}>
                            查询
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content className={Style.content} isLoad={isLoad} isEmpty={false} isError={isError} isScroll={store.main.isFixedContent}>
                <Form form={form}>
                    <Row>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="企业名称"
                                labelAlign={"left"}
                                name="enterpriseName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入企业名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入企业名称" onPressEnter={handleSearchEnterprise} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="企业代码"
                                labelAlign={"left"}
                                name="enterpriseCode"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入企业代码",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入企业代码" onPressEnter={handleSearchEnterprise} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div
                    ref={(ref) => {
                        if (ref != null && tableHeight == 0 && tableHeight != ref.clientHeight) {
                            setTableHeight(ref.clientHeight);
                        }
                    }}
                    className={store.main.isFixedContent ? Style.card_table : null}
                >
                    <Table
                        size="small"
                        rowKey={(record) => record.enterpriseId}
                        columns={[
                            {
                                title: "企业名称",
                                dataIndex: "enterpriseName",
                            },
                            {
                                title: "企业代码",
                                dataIndex: "enterpriseCode",
                            },
                            {
                                title: "操作",
                                width: 150,
                                render: (text, record, recordIndex) => (
                                    <Space>
                                        <Button icon={<FileTextOutlined />} size="default" onClick={() => handleEditEnterprise(record.enterpriseId)}>
                                            修改
                                        </Button>
                                    </Space>
                                ),
                            },
                        ]}
                        dataSource={enterpriseList}
                        rowSelection={{
                            fixed: true,
                            selectedRowKeys: enterpriseIdList,
                            onChange: handleChangeEnterpriseIdList,
                        }}
                        scroll={store.main.isFixedContent ? {y: tableHeight - 130} : {}}
                        pagination={{
                            size: "default",
                            showQuickJumper: true,
                            showSizeChanger: true,
                            current: enterprisePageIndex,
                            pageSize: enterprisePageSize,
                            total: enterpriseTotal,
                            showTotal: (total, range) => "显示" + range[0] + "到" + range[1] + "条,共有" + total + "条",
                            onChange: handleChangeEnterprisePagination,
                            onShowSizeChange: handleChangeEnterprisePagination,
                        }}
                    />
                </div>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

EnterpriseIndex.propTypes = {};

EnterpriseIndex.defaultProps = {};

export default EnterpriseIndex;
